import { schema } from 'normalizr';

const priceScheduleSchema = new schema.Entity('priceSchedules');

export default priceScheduleSchema;
